import AOS from 'aos';
import React from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { AgGridReact } from 'ag-grid-react';
import Select from 'react-select';
import axios from 'axios';
import moment from 'moment';
import { Link } from "react-router-dom";
import ImportedURL from "../../common/api";
import { Currency, Imagevalidation } from "../../common/validate";
import { Spinner } from "react-bootstrap";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import { AiOutlineAppstore, AiOutlineQuestionCircle, GrFormAdd } from "react-icons/ai";
import { Error, Success } from '../../common/swal';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'
import { AC_EMPTY_EDUCATION, AC_HANDLE_INPUT_CHANGE_EDUCATION, AC_LIST_EDUCATION, AC_VIEW_EDUCATION } from '../../actions/educationAction';
import { AC_EMPTY_CARDTYPE, AC_HANDLE_INPUT_CHANGE_CARDTYPE, AC_LIST_CARDTYPE, AC_SPINNER_CARDTYPE, AC_VIEW_CARDTYPE, AC_VIEW_SPINNER_CARDTYPE } from '../../actions/cardtypeAction';

class ListCardtype extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalType: "Add",
            columnDefs: [
                { headerName: '#', valueGetter: "node.rowIndex+1", width: 50, hide: true, sortable: false, filter: false, cellStyle: { 'text-align': 'center' } },
                { headerName: 'Card Type', field: 'cardtype', width: 200, cellStyle: { 'text-align': 'left' }, floatingFilter: true },
                {
                    headerName: 'Card Image', field: 'cardimage', width: 300, floatingFilter: false, headerClass: 'ag-center-header', rowDrag: true,
                    cellRenderer: function (params) {
                        if (params?.value) {
                            return `<div class='logo_center_fix'><img src=${ImportedURL.LIVEURL + params?.value} alt='' width='65px' height='65px' position : 'relative' class="contain_image"/></div>`;
                        }
                    }
                },
                {
                    headerName: 'Status', width: 150, field: 'status', hide: true, cellStyle: { 'text-align': 'center' }, headerClass: 'ag-center-header', suppressMenu: true,
                    cellRenderer: function (params) {
                        if (params.data.status) {
                            return `<span type="button" class="tag tag-green active_status" data-action-type="Status">Active</span>`;
                        } else if (!params.data.status) {
                            return '<span type="button" class="tag tag-danger inactive_status" data-action-type="Status">Inactive</span>';
                        }
                    }
                },
                {
                    headerName: 'Action', width: 150, field: 'actions', cellStyle: { 'text-align': 'center' }, headerClass: 'ag-center-header', suppressMenu: true, sortable: false, filter: false,
                    cellRenderer: function (params) {
                        return params.value;
                    }
                },
            ],
            defaultColumDef: {
                editable: false,
                sortable: true,
                resizable: true,
                filter: true,
                flex: 1,
                minWidth: 100,
            },
            id: '',
            invalidFileError: false,
            cardimageError: false,
            cardtypeError: false,
        }
    }
    componentDidMount() {
        this.props.EmptyCardtype();
        this.props.listCardtype();
    }
    changeModal = (e) => {
        this.props.EmptyCardtype();
        this.setState({ modalType: e.target.id, invalidFileError: false, cardimageError: false, cardtypeError: false, });
        document.getElementById('imageSet').value = '';
    }
    onRowClicked = event => {
        const { AccountState } = this.props;
        const rowValue = event.event.target;
        const value = rowValue.getAttribute('data-action-type');
        // if (value === 'View') {
        //     this.props.ResetRoomArea();
        //     this.setState({ modalType: "View", ccError: false, nameError: false, phonenumberError: false });
        //     this.props.ViewCardtype(event.data);
        // }
        if (value === 'Edit') {
            this.props.ViewSpinnerCartype();
            this.setState({ modalType: "Edit", id: event.data._id, nameError: false, editSpi: true });
            document.getElementById('imageSet').value = '';
            this.props.ViewCardtype(event.data._id);
        }
        if (value === 'Status') {
            Swal.fire({
                title: 'Are you sure you want to change the status?',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: 'Ok',
                imageUrl: 'assets/images/status.png',
                customClass: {
                    popup: 'swal_pop',
                    title: 'swal_title',
                    image: 'swal_image',
                    actions: 'swal_action',
                    confirmButton: 'swal_confirm',
                    cancelButton: 'swal_close',
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post(ImportedURL.API.statusChange, { id: event.data._id, status: !event.data.status, model: 'cardtypes' })
                        .then((data) => {
                            Success('Status updated successfully')
                            this.props.listCardtype();
                        }).catch(({ response }) => {
                            if (response.status == 500) {
                                Error(' Internal Server Error')
                            } else if (response.status == 502) {
                                Error(' Bad Gateway')
                            } else {
                                Error(response.statusMessage)
                            }
                        });
                }
            })
        }
    }
    onGridReady = (params) => {
        this.gridColumnApi = params.columnApi;
        this.gridApi = params.api;
        this.gridApi.sizeColumnsToFit();
    }
    exportToCSV = () => {
        this.gridApi.exportDataAsCsv({
            columnKeys: ['#', 'cardtype'],
            fileName: "cardtypelist.csv",
            processCellCallback: function (params) {
                return params.value;
            }
        })
    }
    exportPDF = () => {
        const { cardtypeState } = this.props;
        const exportData = cardtypeState.listCardtype;
        const unit = "pt";
        const size = "A4";
        const orientation = "landscape";
        const marginLeft = 15;
        var img = new Image();
        img.src = '../assets/images/logo-1.png';
        const doc = new jsPDF(orientation, unit, size);
        doc.setFontSize(15);

        const title = "Card Type List";
        var headers = [['#', 'Card Type',]];
        var data = exportData.map((elt, i) => {
            return [
                i + 1,
                (elt.cardtype) ? elt.cardtype : "---",
            ]
        });

        let content = {
            startY: 70,
            head: headers,
            headStyles: { fillColor: [215, 234, 255], textColor: [28, 48, 120], },
            body: data,
            styles: {
                rowHeight: 30,
                valign: 'middle',
                lineWidth: 0.5,
            },
            margin: {
                left: 10,
                right: 10
            },
            autoPaging: "text",
        };
        doc.addImage(img, 'png', 780, 6, 50, 50);
        doc.setTextColor(28, 48, 120);
        doc.text(title, marginLeft, 40);
        doc.setTextColor(28, 48, 120)
        autoTable(doc, content);
        var totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setFontSize(11);
            doc.setTextColor(110);
            doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() - 100, doc.internal.pageSize.getHeight() - 20);
            doc.setFontSize(11);
            doc.text('This is an auto-generated report from ACWcard (www.acwcard.com)', 20, 575)
        }
        doc.save("cardtypelist.pdf")
    }
    onChange = e => {
        const { SocialMediaState } = this.props;
        const { name, value } = e.target;
        const Error = name + "Error";
        this.setState({ [Error]: false });
        if (name == 'cardimage') {
            this.setState({ cardimageSrc: '' })
            const imgvalidate = Imagevalidation(e.target.files[0]);
            if (imgvalidate) {
                this.setState({ invalidFileError: false })
                this.props.HandleChange('cardimage', e.target.files[0]);
            } else {
                this.setState({ invalidFileError: true })
                document.getElementById('imageSet').value = '';
                this.props.HandleChange('cardimage', '');
            }
        } else {
            let s1 = value.replace(/[^a-z\d\s]+/gi, "");
            let s2 = s1.replace(/[- )(]/g, '')
            var val = s2.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
            this.props.HandleChange(name, val);
        }
    }
    submit = (e) => {
        const getData = this.props.cardtypeState.cardtype;
        const data = { ...getData };
        for (let key in data) {
            if (data.hasOwnProperty(key) && typeof data[key] === 'string') {
                data[key] = data[key].trim();
            }
        }
        let valid = 1;
        if (!data.cardtype) {
            this.setState({ cardtypeError: true })
            valid = 0;
        }
        if (!data.cardimage) {
            this.setState({ cardimageError: true })
            valid = 0;
        }
        if (this.state.invalidFileError) {
            valid = 0;
        }
        if (valid) {
            var formData = new FormData();
            formData.append("cardtype", data.cardtype)
            formData.append("cardimage", data.cardimage)

            this.setState({ saving: true })
            if (this.state.modalType === "Add") {
                axios.post(ImportedURL.API.addCardtype, formData)
                    .then((res) => {
                        this.setState({ saving: false })
                        Success("Card type created successfully");
                        this.props.SpinnerCardtype();
                        this.props.EmptyCardtype();
                        this.props.listCardtype();
                        document.getElementById('imageSet').value = '';
                        let btn = document.getElementById("closeModal");
                        btn.click();
                    }).catch(({ response }) => {
                        this.setState({ saving: false })
                        this.ErrorResponse(response);
                    });
            } else {
                axios.post(ImportedURL.API.updateCardtype + '/' + this.state.id, formData)
                    .then((res) => {
                        this.setState({ saving: false })
                        Success("Card type updated successfully");
                        this.props.SpinnerCardtype();
                        this.props.EmptyCardtype();
                        this.props.listCardtype();
                        let btn = document.getElementById("closeModal");
                        btn.click();
                    }).catch(({ response }) => {
                        this.setState({ saving: false })
                        this.ErrorResponse(response);
                    });
            }
        }
    }

    ErrorResponse = (response) => {
        if (response) {
            if (response.status == 500) {
                Error(response.status + ' Internal Server Error')
            } else if (response.status == 502) {
                Error(response.status + ' Bad Gateway')
            } else if (response.status == 409) {
                Error('Card type already exist')
            } else {
                Error(response.statusMessage)
            }
        } else {
            Error("Bad Gateway")
        }
    }

    render() {
        const { accountState, cardtypeState } = this.props;
        const rowData = cardtypeState.listCardtype;
        const data = cardtypeState.cardtype;
        const spinner = cardtypeState.spinner;
        const viewspinner = cardtypeState.viewspinner;
        const previleges = accountState.previleges;
        const Previlege = previleges.find(obj => { return obj.name == "Card_Type" });
        const editOption = (Previlege && Previlege.edit) ? '<button type="button" class="btn btn-icon" data-action-type="Edit"  data-toggle="modal" data-target="#exampleModal"><i class="fa fa-edit" data-action-type="Edit"></i></button>' : ''

        if (rowData.length > 0) {
            rowData.forEach(object => {
                object.actions = editOption;
            });
        }
        const limitOptions = [
            { value: '25', label: '25' },
            { value: '50', label: '50' },
            { value: '100', label: '100' }
        ]

        return (
            <>
                <div class="content-header">
                    <div class="container-fluid">
                        <div class="row mb-2">
                            <div class="col-12 breadcome_value">
                                <ol class="breadcrumb ">
                                    <li class="breadcrumb-item header_color_breadcome"> <Link to='/admin'>Dasboard</Link></li>
                                    <li class="breadcrumb-item active">List Card Type</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="col-md-12">
                        <div class="card card-primary header_border" >
                            <div class="table-title">
                                <div className="card-header">
                                    <h3 className="card-title d-flex "> <div className='rounded_icon'> <i className="fa fa-address-card-o mr-2" style={{ fontSize: '20px' }}></i></div><h2 class="card-title header_title">LIST Card Type</h2> </h3>
                                    <div className="card-options">
                                        <div className="d-flex justify-content-end">
                                            <div className="header-action mr-2">
                                                {(Previlege && Previlege.add) ? <button type="button" className="btn btn-primary button_color" id='Add' data-toggle="modal" data-target="#exampleModal" onClick={(e) => this.changeModal(e)}> <i className="fa fa-plus mr-2" id='Add' />Add</button> : ''}
                                            </div>
                                            <div>
                                                {(rowData.length > 0) ? <>
                                                    <a className="btn btn-primary btn-sm nav-link dropdown-toggle button_export" data-bs-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i className="fa fa-download mr-2" aria-hidden="true"></i>Export</a>
                                                    <div className="dropdown-menu">
                                                        <a className="dropdown-item" type='button' onClick={this.exportToCSV}><i className="dropdown-icon fa fa-file-excel-o"></i> Excel</a>
                                                        <a className="dropdown-item" type='button' onClick={this.exportPDF}><i className="dropdown-icon fa fa-file-pdf-o"></i> PDF</a>
                                                    </div>
                                                </> : []}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-3">
                                            <label for="exampleInputEmail1">Limit</label>
                                            <div className="form-group">
                                                <Select
                                                    onChange={(e) => this.gridApi.paginationSetPageSize(Number(e.value))}
                                                    options={limitOptions}
                                                    defaultValue={limitOptions[0]}
                                                    className='limit_size overall_select_option'
                                                    styles={{
                                                        menu: provided => ({ ...provided, zIndex: 9999, textAlign: 'left' })
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        <div className="ag-theme-alpine">
                                            <AgGridReact
                                                rowHeight={75}
                                                paginationPageSize={25}
                                                pagination={true}
                                                onRowClicked={this.onRowClicked}
                                                domLayout={"autoHeight"}
                                                defaultColDef={this.state.defaultColumDef}
                                                rowData={rowData}
                                                rowDragManaged={true}
                                                animateRows={true}
                                                columnDefs={this.state.columnDefs}
                                                onGridReady={this.onGridReady}
                                                overlayNoRowsTemplate={"No rows to display"}
                                            >
                                            </AgGridReact>
                                        </div>
                                        {spinner ?
                                            <div className='common_loader_ag_grid'>
                                                <img className='loader_img_style_common_ag_grid' src='../assets/images/logo.jpg' />
                                                <Spinner className='spinner_load_common_ag_grid' animation="border" variant="info" >
                                                </Spinner>
                                            </div>
                                            : ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Modal */}
                    <div className="modal fade" id="exampleModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <div className='rounded_icon'><i className="fa fa-address-card-o mr-2"></i></div>
                                    <h5 className="modal-title" id="exampleModalLabel" style={{ marginTop: '5px' }}>Card Type</h5>
                                    <button type="button" id="closeModal" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" style={{ fontSize: "23px" }} id="closeModal" onClick={this.clear}>
                                            <img src='../../assets/images/cancel.png' />
                                        </span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Card Type<span className="ml-1" style={{ color: 'red' }}>*</span></label>
                                                <input type="text" className="form-control" disabled={this.state.modalType == "View"} name='cardtype' value={data.cardtype} onChange={this.onChange} placeholder="Card Type" />
                                                <div className="invalid-feedback" style={{ display: this.state.cardtypeError ? "block" : 'none' }}> Card Type is required</div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">
                                                    Card Image<span className='ml-1' style={{ color: 'red' }}>*</span>
                                                </label>
                                                <input type="file" accept="image/*" className="form-control" placeholder="Card Image" name='cardimage' onChange={this.onChange} id="imageSet" />
                                                <div className="invalid-feedback" style={{ display: this.state.cardimageError ? "block" : 'none' }}>Card Image is required</div>
                                                <div className="invalid-feedback" style={{ display: this.state.invalidFileError ? "block" : 'none' }}>Invalid file extension</div>
                                            </div>
                                            {data.cardimage ?
                                                <div className="form-group">
                                                    <img src={typeof data.cardimage == 'string' ? ImportedURL.LIVEURL + data.cardimage : window.URL.createObjectURL(data.cardimage)} width="100px" alt='' />
                                                </div>
                                                : ''}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer text-right mandatory">
                                    <label className="form-label text-left mandatory-label"><span className="mr-1" style={{ color: 'red' }}>*</span>Mandatory Fields </label>
                                    <div className="text-right">
                                        {
                                            this.state.saving ?
                                                <button type="button" className="btn commor_save"><i className="fa fa-spinner fa-spin mr-2"></i>{this.state.modalType == "Edit" ? "Updating" : "Saving"}</button>
                                                :
                                                <button type="submit" className="btn commor_save" onClick={this.submit}>
                                                    <i className="fe fe-save mr-2"></i>{this.state.modalType == "Edit" ? "Update" : "Save"}
                                                </button>
                                        }
                                    </div>
                                </div>

                                {/* <div id='overlay' style={{ display: viewspinner ? 'block' : 'none' }}></div>
                                {viewspinner ?
                                    <div className='model_loader_poss'>
                                        <img className='loader_img_style_model' src='../../assets/images/load.png' />
                                        <Spinner className='spinner_load_model' animation="border" variant="info" >
                                        </Spinner>
                                    </div>
                                    : ''} */}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        accountState: state.account,
        cardtypeState: state.cardtype,
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        listCardtype: AC_LIST_CARDTYPE,
        HandleChange: AC_HANDLE_INPUT_CHANGE_CARDTYPE,
        ViewCardtype: AC_VIEW_CARDTYPE,
        EmptyCardtype: AC_EMPTY_CARDTYPE,
        SpinnerCardtype: AC_SPINNER_CARDTYPE,
        ViewSpinnerCartype: AC_VIEW_SPINNER_CARDTYPE,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ListCardtype);